import { useTranslation } from "react-i18next";

import "./styles.css";
import FadeInSection from "../FadeInSection/FadeInSection";
import { useTestimonios } from "../../hook/useTestimonios";

// 🚷ATENCIÓN: NO TOCAR. FUNCIONA Y NO SÉ POR QUÉ.🚷
//
// Este fragmento de código fue escrito entre las 2 y 3 de la mañana,
// bajo los efectos combinados de cafeína, desesperación y un bug que
// solo se manifestaba cuando nadie lo estaba mirando.
//
// No funciona si lo entendés.
// No lo entendés si funciona.
//
// Cualquier intento de refactorizar esto ha resultado en la invocación
// de problemas dimensionales, loops infinitos y un extraño parpadeo en el
// monitor que aún no puedo explicar.
//
// Si necesitás cambiar esto, primero rezá, luego hacé una copia de seguridad...
// y por último, suerte.

const SobreMi = () => {
  const { t } = useTranslation();

  // Obtener testimonios
  const { testimonios, cargando, error } = useTestimonios();

  if (cargando) return <p className="cargando">Cargando testimonios...</p>;
  if (error) return <p className="error">Error al cargar testimonios: {error}</p>;
  return (
    <FadeInSection>
      <div>
        <div className="tpSobreMiPrincipal" id="inicio">
          <div className="sobreMiPortada">
            <span>{t("SobreMi.titulo")}</span>
            <img src="./img/sobreMi/portada.webp" alt="" />
          </div>
          {/* Primera parte de sobre mi donde muestra foto y descripcion */}
          <section>
            <article className="tpAndreaGato">
              <div className="contenido">
                <div className="imagen">
                  <div className="fondoImg">
                    <img src="./img/sobreMi/fondoImg.webp" alt="" />
                  </div>
                  <div className="imgSobremi">
                    <img src="./img/sobreMi/andreasobremi.webp" alt="" />
                  </div>
                </div>

                <div className="sobremi">
                  <p>{t("SobreMi.textoSobreMi")}</p>
                </div>
              </div>
            </article>
          </section>
          {/* Foto del recorrido con patitas de gatos */}
          <FadeInSection>
            <section>
              <article className="tpMainRecorrido">
                <img
                  className="imgnormal"
                  src={t("SobreMi.recorrido")}
                  alt=""
                />
                <img
                  className="imgresponsive"
                  src={t("SobreMi.recorridoResponsive1")}
                  alt=""
                />
                <img
                  className="imgresponsive2"
                  src={t("SobreMi.recorridoResponsive2")}
                  alt=""
                />
              </article>
            </section>
          </FadeInSection>
          {/* Parte de abajo que tiene los testimonios */}
          <FadeInSection>
            <section>
              <article className="tpTestimonios">
                <h1>Testimonios</h1>

                {testimonios.map((t, i) => (
                  <div className="testimonio" key={i}>
                    <div>
                      <p>{t.nombre}</p>
                      <p>{t.descripcion}</p>
                    </div>
                  </div>
                ))}
                
                <button
                  className="boton"
                  onClick={() =>
                  (window.location.href =
                    "https://wa.me/5492901508935?text=Hola%2C%20quiero%20más%20información%20sobre%20tus%20servicios")
                  }
                >
                  {t("SobreMi.botonContacto")}
                </button>
              </article>
            </section>
          </FadeInSection>
        </div>
      </div>
    </FadeInSection>
  );
};

export default SobreMi;
